import React from 'react';
import OptionButton from '../OptionButton';

const Step1 = ({ data, onSelect, overrides }) => {
  const options = overrides?.options || [
    '1–2 times a day',
    'A few times a week',
    'Once a week',
    'Other'
  ];

  return (
    <div className="flex flex-col">
      {/* Promo banner */}
      <div className="flex justify-center mb-8">
        <span className="promo-banner">
          Complete the quiz for 50% off + 1 free gift
        </span>
      </div>

      {/* Question */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-3" style={{ color: '#1a1a2e' }}>
        {overrides?.question || 'How often do you poop?'}
      </h1>
      
      {/* Subtext */}
      <p className="text-base mb-8" style={{ color: '#666' }}>
        {overrides?.subtitle || 'It says a lot about your thyroid health.'}
      </p>

      {/* Options */}
      <div className="flex flex-col gap-3 items-start">
        {options.map((option) => (
          <OptionButton
            key={option}
            selected={data.poopFrequency === option}
            onClick={() => onSelect('poopFrequency', option)}
          >
            {option}
          </OptionButton>
        ))}
      </div>

      {/* Privacy disclaimer */}
      <div className="mt-auto pt-16">
        <p className="text-xs leading-relaxed" style={{ color: '#999' }}>
          We'll ask about your health to provide relevant information about Hashi-aid products. 
          Any personal or health information collected will be used in accordance with our{' '}
          <a href="#" className="underline hover:text-gray-700" style={{ color: '#666' }}>Consumer Health Data Privacy Policy</a> and{' '}
          <a href="#" className="underline hover:text-gray-700" style={{ color: '#666' }}>Privacy Policy</a>. 
          By continuing, you consent to such use. Opt out of marketing by accessing your account or using unsubscribe links in emails.
        </p>
      </div>
    </div>
  );
};

export default Step1;
